import { BudgetClient } from '@frontend/budget/api';
import { Budget } from '@frontend/budget/types';
import { ClassType, EntityType } from '@frontend/common';
import { ReactiveObjectList } from '@frontend/components/list-v2';
import { ConfirmationModal } from '@frontend/components/modal';
import { ICONS } from '@frontend/icons';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../redux/store';
import useLinkBudgetToUsers from './link-budget-to-user-group.controller';

const LinkBudgetToUserGroup = () => {
    const viewProps = useLinkBudgetToUsers();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    return (
        <ReactiveObjectList<Budget>
            fetch={(arg) => BudgetClient.fetchBudgets(arg)}
            dispatch={dispatch}
            columns={{
                columns: ['name']
            }}
            id='link-user-to-budget-list'
            type={EntityType.BUDGET}
            multiSelectOptions={{
                custom: [
                    {
                        text: CommonMessage.BUTTONS.CANCEL,
                        type: ClassType.SECONDARY,
                        onClick: () => navigate('../detail')
                    },
                    {
                        text: CommonMessage.BUTTONS.LINK,
                        enabled: (obj) => obj.length > 0,
                        type: ClassType.PRIMARY,
                        icon: ICONS.BUTTON.LINK,
                        onClick: () =>
                            viewProps.openModal(viewProps.linkModalId, () => (
                                <ConfirmationModal
                                    show={true}
                                    handleClose={() => viewProps.closeModal(viewProps.linkModalId)}
                                    onConfirm={viewProps.onLink}
                                    severity={ClassType.DANGER}
                                    message={
                                        <FormattedMessage
                                            id='link-budget-to-user-group-confirmation-message'
                                            defaultMessage='You are about to link {count, plural, one {# budget} other {# budgets}} to this user group.'
                                            values={{ count: viewProps.selectedObjects.length }}
                                        />
                                    }
                                />
                            ))
                    }
                ]
            }}
            selectedObjects={viewProps.changeSelectedObjects}
        />
    );
};

export default LinkBudgetToUserGroup;
